// ----------------------------------------------------------------------

export default function Typography(theme) {
  return {
    MuiTypography: {
      styleOverrides: {
        paragraph: {
          marginBottom: 0,
        },
        gutterBottom: {
          marginBottom: theme.spacing(2),
        },
      
        linkHover:{
          color: 'red'
        }
      },
    },
  };
}
